// @flow
import React from 'react'
import LoadingIndicator from '../../components/LoadingIndicator'
import styles from './AuthenticatedRouteGuard.module.css'

export default function RefreshingToken () {
  return <div className={styles.loading}><LoadingIndicator /></div>
}
